// extracted by mini-css-extract-plugin
export var actionButton = "_61-1";
export var actionButtons = "_61-2";
export var actions = "_61-0";
export var aiUnread = "_61-10";
export var alignCenter = "_61-h";
export var backWrapper = "_61-3";
export var cellContainer = "_61-4";
export var checkboxContainer = "_61-5";
export var contentContainer = "_61-6";
export var contentHeader = "_61-8";
export var conversationsTableWrapper = "_61-s";
export var draftReplyBadgeContainer = "_61-m";
export var dropdownItem = "_61-b";
export var dropdownItemsContainer = "_61-a";
export var dropdownTitle = "_61-c";
export var errorIcon = "_61-7";
export var filter = "_61-d";
export var gray = "_61-i";
export var headerActionButtons = "_61-e";
export var headerCheckboxContainer = "_61-f";
export var icon = "_61-j";
export var menuContainer = "_61-k";
export var noMoreTicketsIcon = "_61-12";
export var noMoreTicketsSubText = "_61-13";
export var oneLine = "_61-l";
export var optionsButton = "_61-n";
export var plus = "_61-o";
export var portalButtonsWrapper = "_61-g";
export var red = "_61-p";
export var scrolledTop = "_61-9";
export var search = "_61-q";
export var selectedConversationsCount = "_61-r";
export var spinner = "_61-t";
export var strong = "_61-u";
export var summaryCell = "_61-v";
export var tableContainer = "_61-11";
export var tagContainer = "_61-w";
export var threeDots = "_61-x";
export var twoLines = "_61-y";
export var unread = "_61-z";